export enum ListItemTypes {
  TOGGLE = 'toggle_list_item',
  NAVIGATION = 'navigation_list_item',
  HREF = 'href_list_item',
  INERT = 'inert_list_item',
}
